import React from "react";
import IFile from "../../../../../model/interface/file/IFile";
import IReportWidgetProps from "../../../../../model/interface/report/IReportWidgetProps";
import IReportWidgetView from "../../../../../model/interface/report/IReportWidgetView";
import View from "../../../view/View";

class ViewWidget extends React.Component<IReportWidgetProps<IReportWidgetView>> {
    render() {
        const {view} = this.props.options

        return (
            <div>
                <View uuid={view} match={this.props.match} history={this.props.history} standalone={false}/>
            </div>
        );
    }
}

export default ViewWidget